/** Created by azhou on 2019/3/15.*/
<template>
  <div :id="editorId"></div>
</template>

<script>
  import E from 'wangeditor'
  import * as Qiniu from 'qiniu-js'

  export default {
    name: 'RichEditor',
    props: {
      editorId: {         //编辑器ID
        type: String,
        default: 'editor'
      },
      contentProps: {    //设置编辑器内容
        type: String,
        default: ''
      },
      allowUploadImg: {   //是否允许使用上传图片功能
        type: Boolean,
        default: true
      },
      nums: {   //计数第一次和最后一次实时更新
        type: Number,
        default: 0
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        Editor: {},
        num: 0
      }
    },
    watch: {
      contentProps (newVal) {
        if (newVal) {
          this.num++
          sessionStorage.setItem('cnum', this.num)
          if (this.num == 1 || this.nums == this.num) {
            this.Editor.txt.html(newVal);
          }
        }
      },
    },
    mounted () {
      this.Editor = new E(`#${this.editorId}`)
      this.Editor.customConfig.menus = [
        'bold',  // 粗体
        'fontSize',  // 字号
        'fontName',  // 字体
        'italic',  // 斜体
        'underline',  // 下划线
        'strikeThrough',  // 删除线
        'foreColor',  // 文字颜色
        'backColor',  // 背景颜色
        'list',  // 列表
        'justify',  // 对齐方式
        'quote',  // 引用
        'emoticon',  // 表情
        // 'image',  // 插入图片
        'table',  // 表格
        'undo',  // 撤销
        'redo'  // 重复
      ];
      this.Editor.customConfig.colors = [
        '#33ff33','#3399cc','#6666cc','#33ffff','#9999ff','#cc3300','#006666','#99cc66','#ccff00','#ff6600','#000',
        '#ff3366','#3300cc','#ccff66','#006600','#cc0000','#ff9933','#996600','#ff00cc','#ff99cc','#0000ff','#fff','#919191'
      ]
      if (this.allowUploadImg) this.Editor.customConfig.menus.push('image');
      // 隐藏“网络图片”tab
      this.Editor.customConfig.showLinkImg = false
      //显示上传图片
      this.Editor.customConfig.uploadImgShowBase64 = true   // 使用 base64 保存图片
      this.Editor.customConfig.pasteFilterStyle = true //开启粘贴样式过滤
      this.Editor.customConfig.pasteTextHandle = function (content) {
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        if (content == '' && !content) return ''
        let str = content
        str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
        str = str.replace(/<style(([\s\S])*?)<\/style>/g, '')
        str = str.replace(/<\/?[^>]*>/g, '')
        str = str.replace(/[ | ]*\n/g, '\n')
        str = str.replace(/&nbsp;/ig, '')
        return str
      }
      //将编辑器的内容传到父组件
      this.Editor.customConfig.onchange = html => this.$emit('change',html)
      //修改index层级
      this.Editor.customConfig.zIndex = 100;
      this.Editor.create();
      if (this.contentProps) this.Editor.txt.html(this.contentProps);
    }
  }
</script>
